import { useState } from "react";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { authConnector } from "../containers/2step.authentication.container";
import { compose } from "redux";
import "./2step.Authentication.scss";
import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";
import MenuItem from "@material-ui/core/MenuItem";
import {
  allClaims,
  amlWithDev,
} from "../../../shared/ClaimLists/Claim.Aml.All.List";

export const TwoStepAuthentication = ({
  getQrCode,
  getUserKey,
  addUserClaim,
  addUserToAuth,
  AuthKey,
  AuthQr,
  getUserIdentity,
  Identity,
  changeUserPassword,
}) => {
  const [userInfo, changeUserInfo] = useState({
    username: "",
    password: "",
    confirmPassword: "",
    givenName: "",
    surname: "",
  });
  const [userClaimInfo, changeUserClaimInfo] = useState({
    username: "",
    claimName: "",
    claimValue: "",
  });
  const [username, changeUsername] = useState("");
  const [usernameQr, changeUsernameQr] = useState("");
  const [imgCheck, changeImgBool] = useState(true);
  const [usernameId, changeUsernameId] = useState("");
  const [userPasswordInfo, changeUserPasswordInfo] = useState({
    username: "",
    password: "",
  });

  const changeField = (type, data) => {
    if (type === "username") {
      changeUserInfo({
        ...userInfo,
        username: data,
      });
    } else if (type === "password") {
      changeUserInfo({
        ...userInfo,
        password: data,
      });
    } else if (type === "confirmPassword") {
      changeUserInfo({
        ...userInfo,
        confirmPassword: data,
      });
    } else if (type === "givenName") {
      changeUserInfo({
        ...userInfo,
        givenName: data,
      });
    } else if (type === "surname") {
      changeUserInfo({
        ...userInfo,
        surname: data,
      });
    }
  };

  const changeFieldUserClaims = (type, data) => {
    if (type === "username") {
      changeUserClaimInfo({
        ...userClaimInfo,
        username: data,
      });
    } else if (type === "claimName") {
      changeUserClaimInfo({
        ...userClaimInfo,
        claimName: data,
      });
    } else if (type === "claimValue") {
      changeUserClaimInfo({
        ...userClaimInfo,
        claimValue: data,
      });
    }
  };

  return (
    <div>
      <ClaimsWrapper claimAuth={amlWithDev}>
        <Card className="Card-style1">
          <CardActions className="Card-action-justify-center">
            <span className="Span-style1">Add User For Authentication</span>
          </CardActions>
          <CardActions>
            <div style={{ float: "right" }}>
              <TextField
                size="small"
                variant="outlined"
                label={"Username"}
                defaultValue={userInfo.username}
                onChange={(event) => {
                  changeField("username", event.target.value);
                }}
              />
              <br />
              <TextField
                type="password"
                size="small"
                variant="outlined"
                label={"Password"}
                defaultValue={userInfo.password}
                onChange={(event) => {
                  changeField("password", event.target.value);
                }}
              />
              <br />
              <TextField
                type="password"
                size="small"
                variant="outlined"
                label={"Confirm Password"}
                defaultValue={userInfo.confirmPassword}
                onChange={(event) => {
                  changeField("confirmPassword", event.target.value);
                }}
              />
              <br />
              <TextField
                size="small"
                variant="outlined"
                label={"Given Name"}
                defaultValue={userInfo.givenName}
                onChange={(event) => {
                  changeField("givenName", event.target.value);
                }}
              />
              <br />
              <TextField
                size="small"
                variant="outlined"
                label={"Surname"}
                defaultValue={userInfo.surname}
                onChange={(event) => {
                  changeField("surname", event.target.value);
                }}
              />
            </div>
          </CardActions>
          <CardActions className="Card-action-justify-center">
            <Button
              color="primary"
              onClick={() => addUserToAuth(userInfo)}
              variant="contained"
            >
              Add new User
            </Button>
          </CardActions>
          <CardActions className="Card-action-justify-center">
            <span className="Span-style1">Add Claims For The User</span>
          </CardActions>
          <CardActions>
            <div style={{ float: "right" }}>
              <TextField
                size="small"
                variant="outlined"
                label={"Identity"}
                defaultValue={userClaimInfo.username}
                onChange={(event) => {
                  changeFieldUserClaims("username", event.target.value);
                }}
              />
              <br />
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                select
                label={"Claim Name"}
                defaultValue={userClaimInfo.claimName}
                onChange={(event) => {
                  changeFieldUserClaims("claimName", event.target.value);
                }}
              >
                {allClaims.map((role) => {
                  return (
                    <MenuItem value={role} key="role">
                      {role}
                    </MenuItem>
                  );
                })}
              </TextField>
              <br />
            </div>
          </CardActions>
          <CardActions className="Card-action-justify-center">
            <Button
              color="primary"
              onClick={() => addUserClaim(userClaimInfo)}
              variant="contained"
            >
              Add Claim
            </Button>
          </CardActions>
          <CardActions className="Card-action-justify-center">
            <span className="Span-style1">Get User Identity</span>
          </CardActions>
          <CardActions>
            <TextField
              size="small"
              variant="outlined"
              label={"Username"}
              defaultValue={usernameId}
              onChange={(event) => {
                changeUsernameId(event.target.value);
              }}
            />
          </CardActions>
          <CardActions className="Card-action-justify-center">
            <Button
              color="primary"
              onClick={() => getUserIdentity(usernameId)}
              variant="contained"
            >
              Get Identity
            </Button>
          </CardActions>
          <CardActions>
            <textarea
              value={Identity}
              style={{ width: "330px", height: "50px", resize: "none" }}
            />
          </CardActions>
        </Card>
      </ClaimsWrapper>
      <Card className="Card-style2">
        <CardActions className="Card-action-justify-center">
          <span className="Span-style1">Get User Key</span>
        </CardActions>
        <CardActions className="Card-action-justify-center">
          <TextField
            size="small"
            variant="outlined"
            label={"Username"}
            onChange={(event) => changeUsername(event.target.value)}
          />
        </CardActions>
        <CardActions className="Card-action-justify-center">
          <Button
            color="primary"
            onClick={() => getUserKey(username)}
            variant="contained"
          >
            Get User Key
          </Button>
        </CardActions>
        <CardActions>
          <textarea
            value={AuthKey}
            style={{ width: "330px", height: "130px", resize: "none" }}
          />
        </CardActions>
      </Card>
      <br />
      <Card className="Card-style3">
        <CardActions className="Card-action-justify-center">
          <span className="Span-style1">Get QR Code</span>
        </CardActions>
        <CardActions className="Card-action-justify-center">
          <TextField
            size="small"
            variant="outlined"
            onChange={(event) => {
              changeUsernameQr(event.target.value);
            }}
            label={"Username"}
          />
        </CardActions>
        <CardActions className="Card-action-justify-center">
          <Button
            color="primary"
            onClick={() => {
              getQrCode(usernameQr);
              changeImgBool(false);
            }}
            variant="contained"
          >
            Get QR Code
          </Button>
        </CardActions>
        <CardActions className="Card-action-justify-center">
          <img
            alt="new"
            hidden={imgCheck}
            src={AuthQr}
            width="250"
            height="250"
          />
        </CardActions>
      </Card>
      <br />
      <Card className="Card-style3">
        <CardActions className="Card-action-justify-center">
          <span className="Span-style1">Change User Password</span>
        </CardActions>
        <CardActions className="Card-action-justify-center">
          <TextField
            defaultValue={userPasswordInfo.username}
            size="small"
            variant="outlined"
            label="Username"
            onChange={(event) => {
              changeUserPasswordInfo({
                ...userPasswordInfo,
                username: event.target.value,
              });
            }}
          />
        </CardActions>
        <CardActions
          className="Card-action-justify-center"
          style={{ marginTop: "-17px" }}
        >
          <TextField
            type="password"
            defaultValue={userPasswordInfo.password}
            size="small"
            variant="outlined"
            label="New Password"
            onChange={(event) => {
              changeUserPasswordInfo({
                ...userPasswordInfo,
                password: event.target.value,
              });
            }}
          />
        </CardActions>
        <CardActions className="Card-action-justify-center">
          <Button
            color="primary"
            variant="contained"
            onClick={() => changeUserPassword(userPasswordInfo)}
          >
            Change User Password
          </Button>
        </CardActions>
      </Card>
    </div>
  );
};

export default compose(authConnector)(TwoStepAuthentication);
